import { Link } from 'react-router-dom'
import styles from './NotFoundPage.module.css'

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>Такой страницы нет</h1>
      <p className={styles.text}>Возможно, ссылка устарела или в адресе опечатка.</p>
      <Link className={styles.link} to="/">
        На главную
      </Link>
    </div>
  )
}
